//@ts-ignore
import { BaseCL } from '../../vendor/murdej/ts-link-php/src/TsLinkPhp/BaseCL.ts';

export class MyBaseTL extends BaseCL {
	constructor(...args: any[]) {
		super(...args);
		this.onError = (h, e) => console.log('tle', [h, e]);
	}
}
